import { Button, Form } from "antd";
import { useTranslation } from "react-i18next";

import { useGetProfile, useUpdateProfile } from "@/entities/profile";
import SelectLangField from "@/modules/language/language-select-lang-field";

const { useForm } = Form;

const TabGeneral = () => {
  const { t } = useTranslation();
  const [form] = useForm();

  const { profile, isLoading } = useGetProfile();
  const { mutate, isPending } = useUpdateProfile();

  const onSave = ({ language }) => {
    // Just update profile locale. i18n locale will be updated by the
    // <LanguageHandler> loaded in <App> everytime profile locale is updated
    mutate({ locale: language });
  };

  if (isLoading) return null;

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onSave}
      initialValues={{
        language: profile?.locale,
      }}
    >
      <SelectLangField initialValue={profile?.locale} />
      <Button type="primary" htmlType="submit" loading={isPending}>
        {t("global:save")}
      </Button>
    </Form>
  );
};

export default TabGeneral;
